<template>
  <div class="inline-block">
    <vs-button
        v-if="modo === 'cadastro'"
        :disabled="!$atividades.permissoes.includes(14)"
        color="success"
        icon="add"
        icon-pack="material-icons"
        size="small"
        type="relief"
        @click="abrir"
    >Nova Variável
    </vs-button>
    <vs-button
        v-else
        :disabled="!$atividades.permissoes.includes(15)"
        color="primary"
        icon="edit"
        icon-pack="material-icons"
        radius
        size="small"
        type="flat"
        @click="abrir"
    ></vs-button>

    <vs-popup
        :active.sync="modalAtivo"
        :title="modo === 'cadastro' ? 'Cadastrar Variável de Sistema' : 'Editar Variável de Sistema'"
        @close="cancelar"
    >
      <div id="formConfiguracaoSistema" class="vs-con-loading__container">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <label class="vs-input--label">Categoria</label>
            <vs-select
                v-model="form.categoria"
                class="w-full"
                name="categoria"
                placeholder="Selecione a categoria"
            >
              <vs-select-item
                  v-for="(item, index) in categorias"
                  :key="index"
                  :text="item"
                  :value="item"
              />
            </vs-select>
            <span class="text-sm" style="color: #b4aa99">
              A categoria é derivada do prefixo da chave e serve apenas para
              organizar a listagem.
            </span>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
                v-model="form.chave"
                v-validate="'required'"
                class="inputx w-full"
                label="Chave"
                name="chave"
                placeholder="Ex.: WATI_TOKEN"
                @input="onChaveInput"
            />
            <span v-show="errors.has('chave')" class="text-danger text-sm">{{
                $validators.empty
              }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <label class="vs-input--label">Valor</label>
            <vs-textarea
                v-model="form.valor"
                v-validate="'required'"
                class="w-full"
                height="120px"
                name="valor"
            />
            <span v-show="errors.has('valor')" class="text-danger text-sm">{{
                $validators.empty
              }}</span>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
                v-model="form.descricao"
                class="inputx w-full"
                label="Descrição"
                name="descricao"
                placeholder="Para que serve esta variável"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-justify="flex-end" vs-type="flex" vs-w="12">
          <vs-button
              class="mr-3"
              color="dark"
              size="small"
              type="flat"
              @click="cancelar"
          >Cancelar
          </vs-button>
          <vs-button
              v-if="modo === 'edicao'"
              :disabled="!$atividades.permissoes.includes(15)"
              class="mr-3"
              color="danger"
              size="small"
              type="border"
              @click="excluir"
          >Excluir
          </vs-button>
          <vs-button
              color="success"
              size="small"
              type="relief"
              @click="submitForm"
          >{{ modo === "cadastro" ? "Cadastrar" : "Atualizar" }}
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import ConfiguracaoSistemaService from "@/services/ConfiguracaoSistemaService.js";

export default {
  name: "ModalConfiguracaoSistema",
  props: {
    modo: {
      type: String,
      default: "cadastro"
    },
    configuracao: {
      type: Object,
      default: () => ({})
    },
    categorias: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      modalAtivo: false,
      form: {
        chave: "",
        valor: "",
        descricao: "",
        categoria: ""
      }
    };
  },
  methods: {
    async abrir () {
      this.montarFormulario();
      this.$validator.reset();
      this.modalAtivo = true;
    },
    montarFormulario () {
      if (this.modo === "edicao") {
        this.form = {
          chave: this.configuracao.chave,
          valor: this.configuracao.valor,
          descricao: this.configuracao.descricao,
          categoria: ConfiguracaoSistemaService.categoriaDaChave(
              this.configuracao.chave
          )
        };
      } else {
        this.form = { chave: "", valor: "", descricao: "", categoria: "" };
      }
    },
    onChaveInput () {
      this.form.categoria = ConfiguracaoSistemaService.categoriaDaChave(
          this.form.chave
      );
    },
    async submitForm () {
      const valido = await this.$validator.validateAll();
      if (!valido) {
        this.$vs.notify(this.$notify.Empty);
        return;
      }
      if (this.modo === "cadastro") {
        await this.cadastrar();
      } else {
        await this.atualizar();
      }
    },
    async cadastrar () {
      await this.$vs.loading({ container: "#formConfiguracaoSistema", scale: 0.6 });
      try {
        const res = await ConfiguracaoSistemaService.cadastrar(this.form);
        await this.registrarLog("cadastrar", `Cadastro da variável de sistema ${this.form.chave}`);
        this.$vs.notify({
          title: "Sucesso",
          text: `Variável ${this.form.chave} cadastrada com sucesso!`,
          color: "success"
        });
        this.modalAtivo = false;
        this.$emit("update", res);
      } catch (err) {
        await this.tratarErro(err);
      } finally {
        await this.$vs.loading.close("#formConfiguracaoSistema > .con-vs-loading");
      }
    },
    async atualizar () {
      await this.$vs.loading({ container: "#formConfiguracaoSistema", scale: 0.6 });
      try {
        const res = await ConfiguracaoSistemaService.atualizar(
            this.configuracao.id,
            this.form
        );
        await this.registrarLog("atualizar", `Edição da variável de sistema ${this.form.chave}`);
        this.$vs.notify({
          title: "Sucesso",
          text: `Variável ${this.form.chave} atualizada com sucesso!`,
          color: "success"
        });
        this.modalAtivo = false;
        this.$emit("update", res);
      } catch (err) {
        await this.tratarErro(err);
      } finally {
        await this.$vs.loading.close("#formConfiguracaoSistema > .con-vs-loading");
      }
    },
    async excluir () {
      await this.$vs.loading({ container: "#formConfiguracaoSistema", scale: 0.6 });
      try {
        await ConfiguracaoSistemaService.excluir(this.configuracao.id);
        await this.registrarLog("excluir", `Exclusão da variável de sistema ${this.configuracao.chave}`);
        this.$vs.notify({
          title: "Sucesso",
          text: `Variável ${this.configuracao.chave} excluída com sucesso!`,
          color: "success"
        });
        this.modalAtivo = false;
        this.$emit("update");
      } catch (err) {
        await this.tratarErro(err);
      } finally {
        await this.$vs.loading.close("#formConfiguracaoSistema > .con-vs-loading");
      }
    },
    async registrarLog (funcao, texto) {
      const logData = {
        id_colaborador: localStorage.getItem("id"),
        funcao: funcao,
        setor: "administrativo",
        ip: window.localStorage.getItem("ip"),
        texto: texto
      };
      await this.$logger(logData);
    },
    async tratarErro (err) {
      const error = this.$httpErrors(err);
      this.$vs.notify(error);
      if (error.code == 401) {
        await window.localStorage.clear();
        await this.$router.push("/");
      }
    },
    cancelar () {
      this.modalAtivo = false;
      this.montarFormulario();
    }
  },
  components: components
};
</script>

<style scoped>
.inline-block {
  display: inline-block;
}
</style>
